import { getNodeComponent } from '../../node/getNodeComponent/getNodeComponent';
import { getNodesInPath } from '../../node/getNodesInPath/getNodesInPath';
export const getScopeVars = (nodeAttributes, relations) => {
    const grantMap = {};
    const needMap = {};
    const scopeVars = {};
    for (const [key, node] of Object.entries(relations)) {
        const component = getNodeComponent(nodeAttributes, node);
        if (!component.translateScopeVariables) {
            continue;
        }
        const { grants, needs } = component.translateScopeVariables(node);
        grants.forEach((grant) => {
            grantMap[grant] = key;
        });
        if (needs.length > 0) {
            needMap[key] = needs;
        }
        const descendants = grants.length > 0 ? getNodesInPath([key], relations) : null;
        scopeVars[key] = {
            grants,
            needs,
            ancestors: null,
            descendants,
        };
    }
    /*
     * When we're done getting all the grants from nodes
     * figure out the path between nodes with needs & which ancestor grants them.
     */
    for (const [id, needs] of Object.entries(needMap)) {
        const ancestors = needs.reduce((acc, need) => {
            const [_grantingNode, ...nodes] = getNodesInPath([grantMap[need], id], relations);
            acc.push(...nodes);
            return acc;
        }, []);
        /*
         * Ancestors don't need to be in any specific order,
         * we just need to know which nodes are in the path.
         */
        scopeVars[id].ancestors = [...new Set(ancestors)];
    }
    return scopeVars;
};
